import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import BackToTop from "@/components/feature/BackToTop";
import ScrollToTop from "@/components/feature/ScrollToTop";
import Seo from "@/components/feature/Seo";

const values = [
  {
    icon: "ri-user-heart-line",
    title: "以角色为根",
    text: "我们始终围绕火影忍者中那些打动过我们的角色展开，让每一部同人都能被对的人看见。",
  },
  {
    icon: "ri-quill-pen-line",
    title: "尊重创作",
    text: "每一篇同人都是创作者的心血。我们只做分类与推荐，绝不侵扰创作本身，坚持尊重版权。",
  },
  {
    icon: "ri-team-line",
    title: "共建共享",
    text: "火影同人志属于所有热爱忍界的读者与作者，欢迎每一位同好加入，共同丰盈这个小小的天地。",
  },
  {
    icon: "ri-refresh-line",
    title: "持续更新",
    text: "从雏田到鸣人，从樱到佐助，我们每周都在补全新的角色与作品，让内容常看常新。",
  },
];

const principles = [
  "角色优先：同人内容严格按角色归档，方便读者按需浏览。",
  "质量把关：优先收录剧情完整、文笔扎实、反响良好的同人作品。",
  "版权敬畏：所有内容均为粉丝二次创作展示，尊重原版权方。",
  "真实可信：简介与标签如实反映作品内容，不夸大、不误导。",
];

const reviews = [
  {
    name: "晓晨",
    role: "雏田同人爱好者",
    text: "一直很喜欢雏田，这里的雏田同人整理得特别清晰，还有质量不错的推荐，追更很方便！",
    avatar:
      "https://readdy.ai/api/search-image?query=simple_flat_anime_style_avatar_portrait_of_a_smiling_girl_with_dark_hair_warm_orange_background_clean_minimal_high_quality&width=120&height=120&seq=avatar-1-2026&orientation=squarish",
  },
  {
    name: "阿哲",
    role: "佐助同人读者",
    text: "佐助专区收录了好几篇我很喜欢的归途题材，整体氛围拿捏得很准，推荐质量相当在线。",
    avatar:
      "https://readdy.ai/api/search-image?query=simple_flat_anime_style_avatar_portrait_of_a_calm_young_man_with_short_dark_hair_warm_orange_background_clean_minimal_high_quality&width=120&height=120&seq=avatar-2-2026&orientation=squarish",
  },
  {
    name: "柚子茶",
    role: "同人创作者",
    text: "作为写手，在这里投稿很顺畅，编辑沟通也耐心，分类展示让我找到了一批同好读者，特别感动。",
    avatar:
      "https://readdy.ai/api/search-image?query=simple_flat_anime_style_avatar_portrait_of_a_cheerful_woman_with_blonde_hair_warm_orange_background_clean_minimal_high_quality&width=120&height=120&seq=avatar-3-2026&orientation=squarish",
  },
];

const aboutHeader =
  "https://readdy.ai/api/search-image?query=wide_anime_illustration_of_a_warm_sunlit_japanese_village_path_with_sakura_trees_and_distant_hokage_mountain_scene_soft_orange_and_cream_tones_peaceful_welcoming_atmosphere_flat_color_anime_style_high_quality&width=1600&height=520&seq=naruto-about-header&orientation=landscape";

export default function About() {
  return (
    <>
      <ScrollToTop />
      <Seo
        title="关于火影同人志 - 专注火影忍者同人的角色分类与推荐平台"
        description="火影同人志是专注火影忍者同人作品的粉丝分享平台，以角色为核心分类收录日向雏田、春野樱、纲手、宇智波佐助、漩涡鸣人等热门角色的优质二次创作，尊重版权、持续更新。"
        keywords="火影同人志,火影忍者同人平台,同人角色分类,同人投稿"
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "AboutPage",
            name: "关于火影同人志",
            description: "专注火影忍者同人作品的角色分类与推荐平台",
            inLanguage: "zh-CN",
          },
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "火影同人志",
            description: "火影忍者同人作品角色分类与推荐平台",
            email: "contact@huoyingtongren.example",
          },
        ]}
      />

      <Navbar />

      {/* Header */}
      <section className="relative w-full overflow-hidden">
        <div className="absolute inset-0">
          <img
            src={aboutHeader}
            alt="火影同人志 - 温暖的同人社区"
            title="关于火影同人志"
            className="h-full w-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/60 via-foreground-950/40 to-background-50"></div>
        </div>
        <div className="relative mx-auto flex w-full max-w-7xl flex-col items-center px-4 py-20 text-center md:px-6 md:py-28">
          <nav aria-label="面包屑" className="flex items-center gap-1.5 text-xs text-background-100">
            <Link to="/" className="hover:text-primary-300">
              首页
            </Link>
            <i className="ri-arrow-right-s-line" aria-hidden="true"></i>
            <span>关于我们</span>
          </nav>
          <h1 className="mt-4 font-heading text-3xl font-black text-background-50 md:text-5xl">
            关于<span className="text-primary-300">火影同人志</span>
          </h1>
          <p className="mt-5 max-w-2xl text-sm leading-relaxed text-background-100/90 md:text-base">
            因为热爱，所以相聚。我们相信每一段被续写的故事都值得被温柔以待。
          </p>
        </div>
      </section>

      {/* Brand story */}
      <section className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:gap-16">
          <div>
            <span className="text-xs font-bold uppercase tracking-widest text-accent-500">品牌故事</span>
            <h2 className="mt-3 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              给每一个角色的另一种可能，一个安放之处
            </h2>
            <p className="mt-5 text-sm leading-relaxed text-foreground-700 md:text-base">
              《火影忍者》陪伴了无数人的青春，那些角色与羁绊至今仍在心中闪光。我们创办火影同人志，正是希望为这些热爱找到一个聚集地——把分散在四处、以雏田、樱、纲手、佐助、鸣人等人气角色为核心的同人创作，按角色分类整理，让好故事不再被埋没。
            </p>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700 md:text-base">
              从最初一个小小的心愿，到如今持续更新的角色专区与作品推荐，我们始终坚信：同人不是简简单单的二次创作，而是粉丝与角色之间最真挚的情感连接。
            </p>
          </div>
          <div className="flex flex-col justify-center gap-4">
            {[
              { num: "9", label: "位人气角色专区", icon: "ri-user-smile-line" },
              { num: "1500+", label: "收录同人作品", icon: "ri-book-open-line" },
              { num: "每周", label: "持续更新频率", icon: "ri-upload-cloud-line" },
              { num: "100%", label: "尊重创作版权", icon: "ri-shield-check-line" },
            ].map((s) => (
              <div
                key={s.label}
                className="flex items-center gap-4 rounded-lg bg-background-100 p-5"
              >
                <span className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-lg bg-primary-500/10 text-primary-700">
                  <i className={`${s.icon} text-xl`} aria-hidden="true"></i>
                </span>
                <div>
                  <p className="font-heading text-2xl font-black text-foreground-950">{s.num}</p>
                  <p className="text-xs text-foreground-600 md:text-sm">{s.label}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="bg-background-100">
        <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-20">
          <div className="text-center">
            <span className="text-xs font-bold uppercase tracking-widest text-accent-500">发展理念</span>
            <h2 className="mt-3 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              我们坚持怎样的同人社区
            </h2>
          </div>
          <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4 md:gap-5">
            {values.map((v) => (
              <div key={v.title} className="rounded-lg bg-background-50 p-6 md:p-7">
                <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-accent-500/10 text-accent-600">
                  <i className={`${v.icon} text-xl`} aria-hidden="true"></i>
                </span>
                <h3 className="mt-4 font-heading text-base font-bold text-foreground-950 md:text-lg">
                  {v.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{v.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Principles */}
      <section className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-2 lg:gap-12">
          <div>
            <span className="text-xs font-bold uppercase tracking-widest text-accent-500">内容原则</span>
            <h2 className="mt-3 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              内容筛选的四个标准
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              为了让每一位读者都能轻松找到优质同人，我们为内容设定了一套清晰、透明的筛选标准。
            </p>
          </div>
          <ol className="space-y-3">
            {principles.map((p, i) => (
              <li key={p} className="flex items-start gap-4 rounded-lg bg-background-100 p-5">
                <span className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-secondary-500 font-heading text-sm font-bold text-background-50">
                  {i + 1}
                </span>
                <p className="text-sm leading-relaxed text-foreground-800 md:text-base">{p}</p>
              </li>
            ))}
          </ol>
        </div>
      </section>

      {/* Reviews */}
      <section className="bg-background-100">
        <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-20">
          <div className="text-center">
            <span className="text-xs font-bold uppercase tracking-widest text-accent-500">用户心声</span>
            <h2 className="mt-3 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              来自同好们的真实评价
            </h2>
          </div>
          <div className="mt-10 grid grid-cols-1 gap-4 md:grid-cols-3 md:gap-5">
            {reviews.map((r) => (
              <figure key={r.name} className="rounded-lg bg-background-50 p-6 md:p-7">
                <div className="flex items-center gap-2 text-accent-500">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-sm" aria-hidden="true"></i>
                  ))}
                </div>
                <blockquote className="mt-4 text-sm leading-relaxed text-foreground-700">
                  “{r.text}”
                </blockquote>
                <figcaption className="mt-5 flex items-center gap-3">
                  <img
                    src={r.avatar}
                    alt={`${r.name}的头像`}
                    loading="lazy"
                    className="h-11 w-11 rounded-full object-cover"
                  />
                  <div>
                    <p className="text-sm font-bold text-foreground-950">{r.name}</p>
                    <p className="text-xs text-foreground-600">{r.role}</p>
                  </div>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </section>

      {/* Contact CTA */}
      <section className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="rounded-lg bg-secondary-700 px-6 py-10 text-center md:px-12 md:py-14">
          <i className="ri-hand-heart-line text-4xl text-primary-300" aria-hidden="true"></i>
          <h2 className="mt-4 font-heading text-2xl font-black text-background-50 md:text-3xl">
            想投稿或合作？欢迎联系我们
          </h2>
          <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-secondary-100 md:text-base">
            无论是同人投稿、角色专区共建，还是内容建议，我们都十分期待听到你的声音。
            来函请发送至 contact@huoyingtongren.example，我们会在工作日内尽快回复。
          </p>
          <Link
            to="/faq"
            className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600"
          >
            先看看常见问题 <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </Link>
        </div>
      </section>

      <Footer />
      <BackToTop />
    </>
  );
}